// Reading Questions - Original questions for SpeakUp Placement Test
// 10 questions with 3 reading texts (B1 to C1 levels)

export const readingQuestions = [
  // Text 1: Email about Office Party (Questions 51-53)
  {
    id: 51,
    section: 'reading',
    textId: 1,
    textTitle: 'Email about Office Party',
    text: `From: Sarah Johnson
To: All Staff
Subject: End of Year Celebration

Dear Team,

I'm pleased to announce that we will be holding our annual end-of-year party on Friday, December 15th, at 7:00 PM. The event will take place at the Grand Hotel on Baker Street.

This year's theme is "Around the World," so please feel free to dress in traditional clothing from any country you'd like to represent. Prizes will be given for the best costumes!

Dinner will be served at 8:00 PM, and we'll have live music and dancing throughout the evening. Please confirm your attendance by December 1st by replying to this email. Also, let me know if you have any dietary requirements.

We're looking forward to celebrating another successful year with all of you!

Best regards,
Sarah Johnson
HR Manager`,
    question: 'What is the purpose of this email?',
    options: [
      'To announce a meeting',
      'To invite people to a party',
      'To introduce a new employee',
      'To announce a company policy'
    ],
    correct: 1,
    level: 'B1'
  },
  {
    id: 52,
    section: 'reading',
    textId: 1,
    textTitle: 'Email about Office Party',
    text: `From: Sarah Johnson
To: All Staff
Subject: End of Year Celebration

Dear Team,

I'm pleased to announce that we will be holding our annual end-of-year party on Friday, December 15th, at 7:00 PM. The event will take place at the Grand Hotel on Baker Street.

This year's theme is "Around the World," so please feel free to dress in traditional clothing from any country you'd like to represent. Prizes will be given for the best costumes!

Dinner will be served at 8:00 PM, and we'll have live music and dancing throughout the evening. Please confirm your attendance by December 1st by replying to this email. Also, let me know if you have any dietary requirements.

We're looking forward to celebrating another successful year with all of you!

Best regards,
Sarah Johnson
HR Manager`,
    question: 'What should people do before December 1st?',
    options: [
      'Buy their costume',
      'Book a hotel room',
      'Confirm if they will attend',
      'Arrive at the venue'
    ],
    correct: 2,
    level: 'B1'
  },
  {
    id: 53,
    section: 'reading',
    textId: 1,
    textTitle: 'Email about Office Party',
    text: `From: Sarah Johnson
To: All Staff
Subject: End of Year Celebration

Dear Team,

I'm pleased to announce that we will be holding our annual end-of-year party on Friday, December 15th, at 7:00 PM. The event will take place at the Grand Hotel on Baker Street.

This year's theme is "Around the World," so please feel free to dress in traditional clothing from any country you'd like to represent. Prizes will be given for the best costumes!

Dinner will be served at 8:00 PM, and we'll have live music and dancing throughout the evening. Please confirm your attendance by December 1st by replying to this email. Also, let me know if you have any dietary requirements.

We're looking forward to celebrating another successful year with all of you!

Best regards,
Sarah Johnson
HR Manager`,
    question: 'What is special about this year\'s party?',
    options: [
      'It will be at a different location',
      'There will be a costume theme',
      'It will last longer than usual',
      'Only managers can attend'
    ],
    correct: 1,
    level: 'B1'
  },

  // Text 2: Article about Remote Work (Questions 54-57)
  {
    id: 54,
    section: 'reading',
    textId: 2,
    textTitle: 'The Rise of Remote Work',
    text: `The concept of working from home has transformed dramatically over the past decade. What was once considered a privilege has now become a standard practice for millions of workers worldwide. This shift has been accelerated by technological advances and, more recently, by global events that forced companies to adapt quickly.

Research shows that remote work can increase productivity by up to 25% when properly implemented. Employees report higher job satisfaction, better work-life balance, and reduced stress from commuting. However, challenges remain. Many workers struggle with isolation and the blurring of boundaries between personal and professional life.

Companies are now exploring hybrid models, where employees split their time between home and office. This approach aims to maintain the benefits of both environments while addressing their respective drawbacks. As technology continues to evolve and attitudes towards work change, the future of where and how we work remains an exciting question.`,
    question: 'According to the text, remote work has become common because of:',
    options: [
      'Employee demands only',
      'Technology and recent events',
      'Government regulations',
      'Lower office costs'
    ],
    correct: 1,
    level: 'B1'
  },
  {
    id: 55,
    section: 'reading',
    textId: 2,
    textTitle: 'The Rise of Remote Work',
    text: `The concept of working from home has transformed dramatically over the past decade. What was once considered a privilege has now become a standard practice for millions of workers worldwide. This shift has been accelerated by technological advances and, more recently, by global events that forced companies to adapt quickly.

Research shows that remote work can increase productivity by up to 25% when properly implemented. Employees report higher job satisfaction, better work-life balance, and reduced stress from commuting. However, challenges remain. Many workers struggle with isolation and the blurring of boundaries between personal and professional life.

Companies are now exploring hybrid models, where employees split their time between home and office. This approach aims to maintain the benefits of both environments while addressing their respective drawbacks. As technology continues to evolve and attitudes towards work change, the future of where and how we work remains an exciting question.`,
    question: 'What is NOT mentioned as a benefit of remote work?',
    options: [
      'Increased productivity',
      'Better work-life balance',
      'Higher salaries',
      'Reduced commuting stress'
    ],
    correct: 2,
    level: 'B2'
  },
  {
    id: 56,
    section: 'reading',
    textId: 2,
    textTitle: 'The Rise of Remote Work',
    text: `The concept of working from home has transformed dramatically over the past decade. What was once considered a privilege has now become a standard practice for millions of workers worldwide. This shift has been accelerated by technological advances and, more recently, by global events that forced companies to adapt quickly.

Research shows that remote work can increase productivity by up to 25% when properly implemented. Employees report higher job satisfaction, better work-life balance, and reduced stress from commuting. However, challenges remain. Many workers struggle with isolation and the blurring of boundaries between personal and professional life.

Companies are now exploring hybrid models, where employees split their time between home and office. This approach aims to maintain the benefits of both environments while addressing their respective drawbacks. As technology continues to evolve and attitudes towards work change, the future of where and how we work remains an exciting question.`,
    question: 'What challenge of remote work is mentioned?',
    options: [
      'Technical difficulties',
      'Lack of equipment',
      'Feeling isolated',
      'Lower pay'
    ],
    correct: 2,
    level: 'B2'
  },
  {
    id: 57,
    section: 'reading',
    textId: 2,
    textTitle: 'The Rise of Remote Work',
    text: `The concept of working from home has transformed dramatically over the past decade. What was once considered a privilege has now become a standard practice for millions of workers worldwide. This shift has been accelerated by technological advances and, more recently, by global events that forced companies to adapt quickly.

Research shows that remote work can increase productivity by up to 25% when properly implemented. Employees report higher job satisfaction, better work-life balance, and reduced stress from commuting. However, challenges remain. Many workers struggle with isolation and the blurring of boundaries between personal and professional life.

Companies are now exploring hybrid models, where employees split their time between home and office. This approach aims to maintain the benefits of both environments while addressing their respective drawbacks. As technology continues to evolve and attitudes towards work change, the future of where and how we work remains an exciting question.`,
    question: 'What is a hybrid work model?',
    options: [
      'Working only from home',
      'Working only from the office',
      'Splitting time between home and office',
      'Working different jobs at once'
    ],
    correct: 2,
    level: 'B2'
  },

  // Text 3: Article about Artificial Intelligence (Questions 58-60)
  {
    id: 58,
    section: 'reading',
    textId: 3,
    textTitle: 'Artificial Intelligence in Healthcare',
    text: `The integration of artificial intelligence into healthcare systems represents one of the most significant technological advances of our time. Machine learning algorithms can now analyze medical images with accuracy that rivals, and in some cases surpasses, that of experienced radiologists. These systems can detect patterns in vast datasets that would be impossible for humans to process manually.

However, the implementation of AI in healthcare raises profound ethical questions. Issues of data privacy, algorithmic bias, and the potential dehumanization of patient care must be carefully addressed. There is ongoing debate about the extent to which critical medical decisions should be delegated to automated systems, especially when human lives are at stake.

Despite these concerns, the potential benefits are undeniable. AI-powered diagnostic tools could dramatically improve access to healthcare in underserved regions, where specialist doctors are scarce. Predictive analytics could enable earlier intervention in disease progression, potentially saving countless lives. The challenge lies in harnessing this technology responsibly, ensuring that it augments rather than replaces the irreplaceable human elements of medical care: empathy, intuition, and holistic understanding of patient needs.`,
    question: 'According to the text, AI in healthcare can:',
    options: [
      'Replace all doctors',
      'Analyze medical images accurately',
      'Eliminate all diseases',
      'Reduce hospital costs'
    ],
    correct: 1,
    level: 'B2'
  },
  {
    id: 59,
    section: 'reading',
    textId: 3,
    textTitle: 'Artificial Intelligence in Healthcare',
    text: `The integration of artificial intelligence into healthcare systems represents one of the most significant technological advances of our time. Machine learning algorithms can now analyze medical images with accuracy that rivals, and in some cases surpasses, that of experienced radiologists. These systems can detect patterns in vast datasets that would be impossible for humans to process manually.

However, the implementation of AI in healthcare raises profound ethical questions. Issues of data privacy, algorithmic bias, and the potential dehumanization of patient care must be carefully addressed. There is ongoing debate about the extent to which critical medical decisions should be delegated to automated systems, especially when human lives are at stake.

Despite these concerns, the potential benefits are undeniable. AI-powered diagnostic tools could dramatically improve access to healthcare in underserved regions, where specialist doctors are scarce. Predictive analytics could enable earlier intervention in disease progression, potentially saving countless lives. The challenge lies in harnessing this technology responsibly, ensuring that it augments rather than replaces the irreplaceable human elements of medical care: empathy, intuition, and holistic understanding of patient needs.`,
    question: 'What ethical concern is mentioned in the text?',
    options: [
      'AI is too expensive',
      'Data privacy and algorithmic bias',
      'Doctors losing their jobs',
      'Patients refusing treatment'
    ],
    correct: 1,
    level: 'C1'
  },
  {
    id: 60,
    section: 'reading',
    textId: 3,
    textTitle: 'Artificial Intelligence in Healthcare',
    text: `The integration of artificial intelligence into healthcare systems represents one of the most significant technological advances of our time. Machine learning algorithms can now analyze medical images with accuracy that rivals, and in some cases surpasses, that of experienced radiologists. These systems can detect patterns in vast datasets that would be impossible for humans to process manually.

However, the implementation of AI in healthcare raises profound ethical questions. Issues of data privacy, algorithmic bias, and the potential dehumanization of patient care must be carefully addressed. There is ongoing debate about the extent to which critical medical decisions should be delegated to automated systems, especially when human lives are at stake.

Despite these concerns, the potential benefits are undeniable. AI-powered diagnostic tools could dramatically improve access to healthcare in underserved regions, where specialist doctors are scarce. Predictive analytics could enable earlier intervention in disease progression, potentially saving countless lives. The challenge lies in harnessing this technology responsibly, ensuring that it augments rather than replaces the irreplaceable human elements of medical care: empathy, intuition, and holistic understanding of patient needs.`,
    question: 'The author\'s main argument is that AI should:',
    options: [
      'Replace human doctors completely',
      'Be banned from healthcare',
      'Augment but not replace human medical care',
      'Only be used in wealthy countries'
    ],
    correct: 2,
    level: 'C1'
  }
];
